import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

const tabs = [
  {
    name: 'Claude Code',
    config: (apiKey: string) => JSON.stringify({
      mcpServers: {
        "aldan-mcp": {
          url: "http://localhost:3100/mcp",
          headers: {
            Authorization: `Bearer ${apiKey || '<YOUR_API_KEY>'}`
          }
        }
      }
    }, null, 2),
  },
  {
    name: 'Cursor',
    config: (apiKey: string) => JSON.stringify({
      mcpServers: {
        "aldan-mcp": {
          url: "http://localhost:3100/mcp",
          headers: {
            Authorization: `Bearer ${apiKey || '<YOUR_API_KEY>'}`
          }
        }
      }
    }, null, 2),
  },
  {
    name: 'Claude Desktop',
    config: (apiKey: string) => JSON.stringify({
      mcpServers: {
        "aldan-mcp": {
          command: "npx",
          args: ["-y", "mcp-remote", "http://localhost:3100/mcp", `--header`, `Authorization:Bearer ${apiKey || '<YOUR_API_KEY>'}`]
        }
      }
    }, null, 2),
  },
  {
    name: 'Windsurf',
    config: (apiKey: string) => JSON.stringify({
      mcpServers: {
        "aldan-mcp": {
          serverUrl: "http://localhost:3100/mcp",
          headers: {
            Authorization: `Bearer ${apiKey || '<YOUR_API_KEY>'}`
          }
        }
      }
    }, null, 2),
  },
];

interface ConnectionGuideProps {
  apiKey?: string;
}

export default function ConnectionGuide({ apiKey = '' }: ConnectionGuideProps) {
  const [activeTab, setActiveTab] = useState(0);
  const [copied, setCopied] = useState(false);

  const snippet = tabs[activeTab].config(apiKey);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(snippet);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-white">
      <div className="flex border-b border-slate-200">
        {tabs.map((tab, i) => (
          <button
            key={tab.name}
            onClick={() => setActiveTab(i)}
            className={`px-4 py-2.5 text-sm font-medium transition-colors ${
              activeTab === i
                ? 'border-b-2 border-slate-900 text-slate-900'
                : 'text-slate-500 hover:text-slate-700'
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>

      <div className="relative p-4">
        <button
          onClick={handleCopy}
          className="absolute right-4 top-4 rounded-lg border border-slate-200 bg-white p-1.5 text-slate-400 hover:text-slate-600"
          title="Copy to clipboard"
        >
          {copied ? <Check className="h-4 w-4 text-green-500" /> : <Copy className="h-4 w-4" />}
        </button>
        <pre className="overflow-auto rounded-lg bg-slate-900 p-4 text-sm text-slate-100">
          {snippet}
        </pre>
      </div>
    </div>
  );
}
